import React from "react";
import "./homestyles.css";
import { useState } from "react";
import { Navigate } from "react-router-dom";

import SignUpForm from "../components/signUpForm"
import SignInForm from "../components/signInForm"

export default function Home() {
    const [isSignup, setSignUpState] = useState(true)

    var signInClass = "headerButtonUnSelected"
    var signUpClass = "headerButtonSelected"

    if (isSignup) {
        signUpClass = "headerButtonSelected"
        signInClass = "headerButtonUnSelected"

    }
    else {
        signUpClass = "headerButtonUnSelected"
        signInClass = "headerButtonSelected"
    }


    function switchPanel(trigger) {
        if (trigger == "signin") {
            setSignUpState(false)
        }
        else {
            setSignUpState(true)
        }
    }

    if (localStorage.getItem("username") != null) {
        return (
            <Navigate to="/dashboard" />
        )
    }
    return (
        <React.Fragment>
            <div className="col center">
                <div className="tagline col ">
                    <span style={{ fontWeight: "300", fontSize: "50px", color: "grey" }}>cryptracker</span>
                    <span style={{ fontWeight: "200", color: "yellowgreen" }}>A simple way to track cryptos.</span>
                </div>
                <div className="form col">
                    <div className="headerOptions row">
                        <button className={signUpClass} style={{ borderRight: "1px solid grey" }} onClick={() => { switchPanel("signup") }}>
                            Signup
                        </button>
                        <button className={signInClass} onClick={() => { switchPanel("signin") }}>
                            Login
                        </button>
                    </div>
                    <div className="form-content col">
                        {isSignup ? <SignUpForm handler={switchPanel} /> : <SignInForm />}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}